// extracted by mini-css-extract-plugin
export default {"productGrid":"h0-z","centerLink":"i0-z","productSection":"j0-z","item":"k0-z","ctaButton":"l0-z"};